"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var BillIcon = function BillIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-bill",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.7 64",
    width: props.width || "100px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M89.7,64H15.84a2,2,0,0,1,0-4H87.71V15.84a2,2,0,0,1,4,0V62A2,2,0,0,1,89.7,64Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M75.85,50.15H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H75.85a2,2,0,0,1,2,2V48.16A2,2,0,0,1,75.85,50.15ZM4,46.16H73.86V4H4Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M38.92,36.3A11.23,11.23,0,1,1,50.15,25.08,11.23,11.23,0,0,1,38.92,36.3Zm0-18.46a7.24,7.24,0,1,0,7.24,7.24A7.24,7.24,0,0,0,38.92,17.84Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M75.85,22.45A20.48,20.48,0,0,1,55.4,2a2,2,0,0,1,2-2H75.85a2,2,0,0,1,2,2V20.46A2,2,0,0,1,75.85,22.45ZM59.5,4A16.52,16.52,0,0,0,73.86,18.35V4Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M75.85,50.15H57.39a2,2,0,0,1-2-2A20.48,20.48,0,0,1,75.85,27.7a2,2,0,0,1,2,2V48.16a2,2,0,0,1-2,2Zm-16.35-4H73.86V31.81A16.5,16.5,0,0,0,59.5,46.16Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M2,22.45a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H20.46a2,2,0,0,1,2,2A20.49,20.49,0,0,1,2,22.45ZM4,4V18.35A16.52,16.52,0,0,0,18.35,4Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M2,50.15a2,2,0,0,1-1.41-.58A2,2,0,0,1,0,48.16V29.69a2,2,0,0,1,2-2A20.49,20.49,0,0,1,22.45,48.16a2,2,0,0,1-2,2Zm18.47-2h0ZM4,31.81V46.16H18.35A16.5,16.5,0,0,0,4,31.81Z"
  }))));
};

var _default = BillIcon;
exports["default"] = _default;